import * as am5stock from "@amcharts/amcharts5/stock";

const Indicator = [
  {
    name: "Awesome Oscillator",
    class: am5stock.AwesomeOscillator,
    fav: false,
    current: false,
    backgroundid: "ac-background",
    chatid: "ac-scale",
  },
  {
    name: "Aroon",
    class: am5stock.Aroon,
    fav: false,
    current: false,
    backgroundid: "aro-background",
    chatid: "aroon-scale",
  },
  {
    name: "Bears Power",
    class: am5stock.BullBearPower,
    fav: false,
    current: false,
    backgroundid: "bearsPower-background",
    chatid: "bearsPower-scale",
  },
  {
    name: "Bulls Power",
    class: am5stock.BullBearPower,
    fav: false,
    current: false,
    backgroundid: "bullsPower-background",
    chatid: "bullsPower-scale",
  },
  // {
  //   name: "DeMarker",
  //   class: am5stock.,
  //   fav: false,
  //   current: false,
  //   backgroundid: "demarker-background",
  //   chatid: "demarker-scale"
  // },
  // {
  //   name: "Fractal Chaos Bands",
  //   class: am5stock.,
  //   fav: false,
  //   current: false,
  //   backgroundid: "",
  //   chatid: ""
  // },
  // {
  //   name: "Rate of Change",
  //   class: am5stock.,
  //   fav: false,
  //   current: false,
  //   backgroundid: "roc-background",
  //   chatid: "roc-scale"
  // },
  {
    name: "MACD",
    class: am5stock.MACD,
    fav: false,
    current: false,
    backgroundid: "adx-background",
    chatid: "adx-scale",
  },
  {
    name: "Average True Range",
    class: am5stock.AverageTrueRange,
    fav: false,
    current: false,
    backgroundid: "atr-background",
    chatid: "atr-scale",
  },
  {
    name: "Bollinger Bands",
    class: am5stock.BollingerBands,
    fav: false,
    current: false,
    backgroundid: "",
    chatid: "",
  },
  {
    name: "Momentum",
    class: am5stock.Momentum,
    fav: false,
    current: false,
    backgroundid: "momentum-background",
    chatid: "momentum-scale",
  },
  // {
  //   name: "Parabolic SAR",
  //   class: am5stock.p,
  //   fav: false,
  //   current: false,
  //   backgroundid: "",
  //   chatid: ""
  // },

  // {
  //   name: "Vortex",
  //   class: am5stock.,
  //   fav: false,
  //   current: false,
  //   backgroundid: "vortex-background",
  //   chatid: "vortex-scale"
  // },
  // {
  //   name: "Alligator",
  //   class: am5stock.,
  //   fav: false,
  //   current: false,
  //   backgroundid: "",
  //   chatid: ""
  // },

  // {
  //   name: "Donchian Channels",
  //   class: am5stock.,
  //   fav: false,
  //   current: false,
  //   backgroundid: "",
  //   chatid: ""
  // },

  // {
  //   name: "Keltner Channel",
  //   class: am5stock.k,
  //   fav: false,
  //   current: false,
  //   backgroundid: "",
  //   chatid: ""
  // },
  {
    name: "Moving Average",
    class: am5stock.MovingAverage, // default to SMA (you can switch to EMA if needed)
    fav: false,
    current: false,
    backgroundid: "",
    chatid: "",
  },
  {
    name: "RSI",
    class: am5stock.ResetControl,
    fav: false,
    current: false,
    backgroundid: "rsi-background",
    chatid: "rsi-scale",
  },
  {
    name: "Stochastic Oscillator",
    class: am5stock.StochasticOscillator,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
  {
    name: "Williams %R",
    class: am5stock.WilliamsR,
    fav: false,
    current: false,
    backgroundid: "williamsr-background",
    chatid: "williamsr-scale",
  },
  {
    name: "MACross",
    class: am5stock.MACross,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
  {
    name: "ZigZag",
    class: am5stock.ZigZag,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
   
   {
    name: "Stochastic Momentum Index",
    class: am5stock.StochasticMomentumIndex,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
  {
    name: "Moving Average Deviation",
    class: am5stock.MovingAverageDeviation,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
  {
    name: "Moving Average Envelope",
    class: am5stock.MovingAverageEnvelope,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
   {
    name: "Acceleration Bands",
    class: am5stock.AccelerationBands,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
   {
    name: "Accumulation Distribution",
    class: am5stock.AccumulationDistribution,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
     {
    name: "Accumulative Swing Index",
    class: am5stock.AccumulativeSwingIndex,
    fav: false,
    current: false,
    backgroundid: "stochastic-background",
    chatid: "stochastic-scale",
  },
];

export default Indicator;
